import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {SharedModule} from '../shared/shared.module';
import {LayoutModule} from '../layout/layout.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AccordionModule} from 'primeng/accordion';
import {CheckboxModule} from 'primeng/checkbox';
import {SharedModule as PNGSharedModule} from 'primeng/api';
import {ClickOutsideModule} from 'ng-click-outside';
import {DynamicFormModule} from '../shared/dynamic-form/dynamic-form.module';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {COMPONENTS, SERVICES, specimensAndSamplesComponents, specimensAndSamplesServices} from './index';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    PNGSharedModule,
    CheckboxModule,
    LayoutModule,
    AccordionModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    CalendarModule,
    ClickOutsideModule,
    DynamicFormModule
  ],
  declarations: [...specimensAndSamplesComponents, COMPONENTS],
  exports: [...COMPONENTS],
  providers: [...SERVICES, specimensAndSamplesServices]
})

export class SpecimensAndSamplesModule {
}
